import api, { createAuthenticatedApi } from '../api';
import { ILogt } from '../models/logT';
import { LogtSearchCriteria } from '../models/logTSearchCriteria';
import LogTSearchResponse from '../types/logTSearchResponse';
import { formatZuluDateTimeForApi } from '../utils/zuluTime';

const endpoint = 'logt';

const isPaginatedLogtResponse = (data: unknown): data is LogTSearchResponse => {
    if (!data || typeof data !== 'object') {
        return false;
    }

    const candidate = data as { logs?: unknown; totalPages?: unknown; totalCount?: unknown };
    return Array.isArray(candidate.logs)
        && typeof candidate.totalPages === 'number'
        && typeof candidate.totalCount === 'number';
};

export const searchLogTs = async (
    page: number,
    limit: number,
    searchCriteria: LogtSearchCriteria,
    accessToken: string,
    useExtendedSearchApi: boolean = false,
    signal?: AbortSignal
): Promise<LogTSearchResponse> => {
    try {
        // Use the authenticated API helper
        const authenticatedApi = createAuthenticatedApi(accessToken);    

        const searchParams = {
            ...searchCriteria,
            ...(searchCriteria.StartDate ? { StartDate: formatZuluDateTimeForApi(searchCriteria.StartDate) } : {}),
            ...(searchCriteria.EndDate ? { EndDate: formatZuluDateTimeForApi(searchCriteria.EndDate) } : {})
        };
        const searchEndpoint = useExtendedSearchApi ? `${endpoint}/search-extended` : `${endpoint}/search`;
        const response = await authenticatedApi.post(searchEndpoint, searchParams, {
            params: {
                page,
                limit
            },
            signal
        });

        if (!isPaginatedLogtResponse(response.data)) {
            throw new Error('Invalid search response format.');
        }

        return response.data;
    } catch (error: any) {
        if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
            throw error;
        }
        throw new Error('Failed to search log entries: ' + error.message);
    }
};

export const searchLogTsAll = async (searchCriteria: LogtSearchCriteria, accessToken?: string): Promise<ILogt[]> => {
    try {
        const apiClient = accessToken ? createAuthenticatedApi(accessToken) : api;
        console.log('Searching log entries with criteria:', searchCriteria); 

        const searchParams = {
            ...searchCriteria,
            ...(searchCriteria.StartDate ? { StartDate: formatZuluDateTimeForApi(searchCriteria.StartDate) } : {}),
            ...(searchCriteria.EndDate ? { EndDate: formatZuluDateTimeForApi(searchCriteria.EndDate) } : {})
        };
        const response = await apiClient.post(`${endpoint}/searchAllLogs`, searchParams);
        return response.data;
    } catch (error: any) {
        throw new Error('Failed to search all log entries: ' + error.message);
    }
};
